import camelCase from 'camelcase';

type GraphqlErrorType = Array<{ message: string }>;

export const getGraphqlErrors = (err: any) => {
  const graphQLErrors: GraphqlErrorType = err?.graphQLErrors;
  if (graphQLErrors?.length) {
    try {
      return JSON.parse(graphQLErrors[0].message);
    } catch {
      // Message is a string, not JSON
      return graphQLErrors[0].message;
    }
  }
  return undefined;
};

export const hasGraphqlValidationFailures = (err: any) => {
  const graphqlErrors = getGraphqlErrors(err);
  return !!graphqlErrors?.validation_failures;
};

export const getGraphqlValidationErrors = (err: any) => {
  const graphqlErrors = getGraphqlErrors(err);
  const errors = graphqlErrors?.validation_failures;
  if (errors && Object.keys(errors).length) {
    const errorStatus: Record<string, string> = {};
    Object.keys(errors).forEach((field) => {
      errorStatus[camelCase(field)] = errors[field];
    });
    return errorStatus;
  }
  return undefined;
};
